import { API_BASE } from '../apiBase';
// src/employees/EmployeesTimecardList.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function EmployeesTimecardList() {
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${API_BASE}/employees`, {
          headers: { Authorization: token },
        });
        setEmployees(res.data);
      } catch (err) {
        console.error('Failed to load employees:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchEmployees();
  }, []);

  const filteredEmployees = employees.filter(emp =>
    emp.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    emp.role?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    emp.employeeNumber?.includes(searchTerm)
  );

  if (loading) {
    return <div className="min-h-screen bg-gray-950 p-8 text-zinc-100">Loading timecards overview...</div>;
  }

  return (
    <div className="min-h-screen bg-gray-950 text-zinc-100 p-8 space-y-8">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-6">
        <h1 className="text-3xl font-bold tracking-tight">Employees Timecards</h1>
        <button
          onClick={() => navigate('/employees')}
          className="px-6 py-3 bg-gray-700 hover:bg-gray-600 rounded-xl font-medium transition-all"
        >
          Back to Employees
        </button>
      </div>

      <div className="max-w-xl">
        <input
          type="text"
          placeholder="Search by name, role, or employee #..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          className="w-full px-5 py-3.5 bg-gray-900 border border-gray-800 rounded-xl text-zinc-200 placeholder-zinc-500 focus:outline-none focus:border-indigo-600/60 focus:ring-2 focus:ring-indigo-600/20 transition-all"
        />
      </div>

      <div className="bg-gray-900 rounded-2xl border border-gray-800/50 overflow-hidden shadow-2xl">
        <table className="min-w-full divide-y divide-gray-800/60">
          <thead className="bg-gray-950/30">
            <tr>
              <th className="px-8 py-5 text-left text-xs font-semibold text-zinc-400 uppercase tracking-wider">Employee #</th>
              <th className="px-8 py-5 text-left text-xs font-semibold text-zinc-400 uppercase tracking-wider">Name</th>
              <th className="px-8 py-5 text-left text-xs font-semibold text-zinc-400 uppercase tracking-wider">Role</th>
              <th className="px-8 py-5 text-left text-xs font-semibold text-zinc-400 uppercase tracking-wider">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-800/40">
            {filteredEmployees.length === 0 ? (
              <tr>
                <td colSpan={4} className="px-8 py-20 text-center text-zinc-500 text-lg">
                  No employees found. Try adjusting your search.
                </td>
              </tr>
            ) : (
              filteredEmployees.map(emp => (
                <tr
                  key={emp._id}
                  className="bg-gray-900 hover:bg-gray-800/50 hover:shadow-sm transition-all duration-200 cursor-pointer group"
                  onClick={() => navigate(`/employees/${emp._id}/timecard`)}
                >
                  <td className="px-8 py-6 whitespace-nowrap text-sm font-medium text-zinc-100">
                    {emp.employeeNumber || '—'}
                  </td>
                  <td className="px-8 py-6 whitespace-nowrap text-sm font-medium text-zinc-100">
                    {emp.name}
                  </td>
                  <td className="px-8 py-6 whitespace-nowrap text-sm text-zinc-300">
                    {emp.role || 'N/A'}
                  </td>
                  <td className="px-8 py-6 whitespace-nowrap">
                    <span className={`inline-block px-3 py-1 text-xs font-medium rounded-full ${
                      emp.status === 'Active' ? 'bg-green-600/80 text-white' :
                      emp.status === 'On Leave' ? 'bg-yellow-600/80 text-white' :
                      emp.status === 'Terminated' ? 'bg-red-600/80 text-white' :
                      'bg-gray-600/80 text-white'
                    }`}>
                      {emp.status}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <p className="text-center text-zinc-500 italic mt-6">
        Select an employee to view or edit their timecard
      </p>
    </div>
  );
}

export default EmployeesTimecardList;